import SettingsServices from "src/api-services/settings-logs-sevrices";
export const createLogsSlice = (set) => ({
  logs: [],
  log: {},
  logsLoading: false,
  logLoading: false,

  fetchLogsFunction: async () => {
    set((state) => ({
      ...state,
      logsLoading: true,
    }));
    try {
      const response = await SettingsServices.getLogs();
      set((state) => ({
        ...state,
        logs: response.data.data,
        logsLoading: false,
      }));
    } catch {
      set((state) => ({
        ...state,
        logsLoading: false,
      }));
    }
  },
  fetchLogFunction: async (id) => {
    set((state) => ({
      ...state,
      logLoading: true,
    }));
    try {
      const response = await SettingsServices.getLog(id);
      set((state) => ({
        ...state,
        log: response.data.data,
        logLoading: false,
      }));
    } catch {
      set((state) => ({
        ...state,
        logLoading: false,
      }));
    }
  },
  fetchLogsByUserFunction: async (id, date) => {
    set((state) => ({
      ...state,
      logsLoading: true,
    }));
    try {
      const response = await SettingsServices.getLogsByUser(id, date);
      set((state) => ({
        ...state,
        logs: response.data.data,
        logsLoading: false,
      }));
    } catch {
      set((state) => ({
        ...state,
        logsLoading: false,
      }));
    }
  }
});
